export default __webpack_public_path__ + "locales/ru/Common.json?hash=839bc15768751400b9a58de8df23f98c";